<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  name: 'product',
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>
</style>
